<script setup lang="ts">
/**
 * Bouton d'appel à l'action de la page publique : pilule, libellé, pastille ronde avec flèche.
 * À la pression, la pastille glisse vers la droite (le geste « avancer »), sans ombre.
 * `light` : pour les fonds sombres ou en action secondaire.
 */
import { computed } from 'vue'
import { RouterLink, type RouteLocationRaw } from 'vue-router'

import Icon from './Icon.vue'

const props = withDefaults(
  defineProps<{
    to: RouteLocationRaw
    tone?: 'accent' | 'light'
    size?: 'default' | 'compact'
    block?: boolean
  }>(),
  { tone: 'accent', size: 'default', block: false },
)

const classes = computed(() => [
  'group inline-flex select-none items-center justify-between rounded-full py-1.5 pr-1.5 font-medium transition-colors duration-160 ease-standard',
  props.size === 'default' ? 'h-control gap-4 pl-6 text-body' : 'h-11 gap-3 pl-5 text-label',
  props.block ? 'w-full' : '',
  props.tone === 'accent'
    ? 'bg-accent-strong text-ink-inverse hover:bg-accent-pressed active:bg-accent-pressed'
    : 'border border-line bg-bg text-ink hover:bg-surface-soft active:bg-surface',
])

const knob = computed(() => [
  'flex shrink-0 items-center justify-center rounded-full transition-transform duration-160 ease-standard group-hover:translate-x-0.5 group-active:translate-x-1',
  props.size === 'default' ? 'size-10' : 'size-8',
  props.tone === 'accent' ? 'bg-bg text-accent-strong' : 'bg-accent-strong text-ink-inverse',
])
</script>

<template>
  <RouterLink :to="to" :class="classes">
    <span><slot /></span>
    <span :class="knob" aria-hidden="true"><Icon name="forward" :size="20" /></span>
  </RouterLink>
</template>
